import connect from 'components/Shared/connect';
import styles from './styles.scss';
import cn from 'classnames';
import { LogoOwnProps } from 'components/Shared/Logo/props';

interface MergedProps extends LogoOwnProps {
  logoUrl: string;
}

const Logo = ({ className, wrapperClassName, logoUrl }: MergedProps) => (
  <a className={cn(styles.logo, wrapperClassName)} href="/">
    <img className={cn(className)} src={logoUrl} />
  </a>
);

export default connect<MergedProps, LogoOwnProps>(({ appShell }) => ({
  logoUrl: appShell.logoUrl
}))(Logo);
